import { useQuery } from "@tanstack/react-query"
import { whatsappOpeningMessagesQuery } from "../../../lib/templates/openingMessages/whatsappOpeningMessagesQuery"

export function useWhatsappOpeningMessagesQuery(
  ...args: Parameters<typeof whatsappOpeningMessagesQuery>
) {
  return useQuery(whatsappOpeningMessagesQuery(...args))
}
